<main id="main-content" class="h-screen flex flex-col pl-10 py-4 pr-4 transition-all duration-0">
    <div class="w-full flex flex-col p-2 items-center gap-2">
        <div class="w-full flex flex-row items-center justify-between">
            <div class="w-full flex gap-2 items-center justify-start">
                <h1 class="oswald-font text-3xl uppercase">Custom Pages</h1>
                <div data-popover-target="popover-right" data-popover-placement="right" type="button">
                    <lucide-icon [name]="icons.CircleHelp" [size]=24 class="text-red-500"></lucide-icon>
                </div>
                <div data-popover id="popover-right" role="tooltip" class="absolute z-30 invisible inline-block w-fit max-w-[600px] text-sm text-gray-500 transition-opacity duration-300 bg-white border border-gray-200 rounded-md shadow-xs opacity-0">
                    <div class="px-3 py-2 space-y-2">
                        <p>
                            To create a customized section, click on
                            <span class="inline-flex px-1.5 h-8 rounded-md border-2 border-nside-gray-200 text-nside-gray-200 oswald-font flex items-center justify-center gap-2">
                                <lucide-icon [img]="icons.Plus"></lucide-icon>
                                Add New Page
                            </span>. In the pop-up, enter the title of the section. Each section's title must be distinct.
                        </p>
                        <p>
                            Once the page has been created, it will appear under the Custom Pages section. To edit the custom page's information, click on the page name.
                        </p>
                    </div>
                    <div data-popper-arrow></div>
                </div>
            </div>
        </div>
    </div>

    <!-- MAIN CONTENT -->
    <div class="p-2 w-full flex flex-grow flex-col items-start gap-8 overflow-y-auto">
        <div class="w-full max-h-full bg-white rounded-md shadow-custom-2 p-6 flex flex-col items-center justify-start gap-4">
            <div class="w-full flex items-center justify-between gap-2">
                <h2 class="oswald-font text-3xl">Custom Pages</h2>
                <button *ngIf="canSave()" (click)="$event.preventDefault(); openAdd();"
                    class="w-22 px-2.5 py-1 rounded-md border-2 border-nside-gray-200 text-nside-gray-200 hover:text-white hover:bg-nside-gray-200 oswald-font flex items-center justify-center gap-2">
                    <lucide-icon [img]="icons.Plus"></lucide-icon>
                    Add New Page
                </button>
            </div>

            <ng-container *ngIf="customPages.length > 0; else emptyList">
                <div class="w-full h-full flex flex-col items-start gap-1 overflow-y-auto">
                    <div class="w-full flex gap-6 items-center justify-between" *ngFor="let page of customPages; let i = index">
                        <button (click)="$event.preventDefault(); openPage(page);"
                            class="min-w-0 flex-1 text-start py-1 font-semibold border-b border-gray-200 hover:text-nside-orange-400 whitespace-pre-line break-words [overflow-wrap:anywhere]">
                            {{ i + 1 }}. {{ page.title }}
                        </button>
                        <div *ngIf="canSave()" class="flex items-center justify-center gap-1">
                            <button (click)="$event.preventDefault(); openEdit(page);"
                                class="w-8 h-8 rounded border-2 border-nside-gray-200 text-nside-gray-200 flex items-center justify-center hover:text-white hover:bg-nside-gray-200">
                                <lucide-icon [img]="icons.Pencil" size="20"></lucide-icon>
                            </button>
                            <button (click)="$event.preventDefault(); openDelete(page);"
                                class="w-8 h-8 flex items-center justify-center font-normal text-white oswald-font bg-gradient-to-b from-nside-gray-300 to-nside-gray-400 rounded hover:bg-gradient-to-b hover:from-red-600 hover:to-red-700 cursor-pointer">
                                <lucide-icon [img]="icons.Trash2" size="20"></lucide-icon>
                            </button>
                        </div>
                    </div>
                </div>
            </ng-container>
            <ng-template #emptyList>
                <div class="w-full">
                    <p class="w-full text-gray-500 font-medium">Empty custom pages.</p>
                    <p *ngIf="canSave()" class="w-full text-gray-500 font-medium">
                        Click the button above to create a new custom page.
                    </p>
                </div>
            </ng-template>
        </div>
    </div>

    <prv-next-buttons></prv-next-buttons>
</main>

<introduction></introduction>

<add-custom-page
    *ngIf="showAddCustomPage"
    (onClose)="closeAdd()"
    (onSave)="handleSaved($event)"
></add-custom-page>

<edit-custom-page
    *ngIf="showEditCustomPage"
    [customPage]="editItem"
    (onClose)="closeEdit()"
    (onSave)="handleSaved($event)"
></edit-custom-page>

<delete-confirmation
    *ngIf="showDeleteConfirmation"
    [text]="'this custom page'"
    [itemToDelete]="deleteItem"
    (onClose)="closeDelete()"
    (onDelete)="handleDelete($event)"
></delete-confirmation>

<popup-message [type]="messageModal" [message]="popupMessage" (close)="resetMessageModal()"></popup-message>

<div *ngIf="loading"><spinner></spinner></div>
